import React, {useState} from "react";
import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {sanitizeText} from "../../../libs/utils";
import {isRichEditableText} from "../../../libs/contentEditableText";
import BgTransformer from "../../../layout/BgTransformer";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {useSetting} from "../../../contexts/setting";

const StreamYardWebinar = ({id, zoom}) => {
  const {type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const [isInline] = useState(true);
  const {titles} = useEdits();
  const storedTitle = titles[id] || titles.main || "";
  const title = isRichEditableText(storedTitle) ? storedTitle : sanitizeText(storedTitle);

  return (
    <div id={id} className={`template ${type.value}`} style={{"--zoom-level": zoom}}>
      <div>
        <BgTransformer src={bgUrl} id={id} />

        <div className="content">
          <div className="title">
            <Textarea id={id} text={title} inline={isInline} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreamYardWebinar;
